import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../../config/i18n';

class DriveInventoryView extends React.Component {
  renderDrives() {
    let { inventory } = this.props;
    return inventory.drives.map((drive, index) => {
      return (
        <div className="clearfix" key={index}>
          <div className="col col-3 py1">
            <div className="h4">{drive.driveType}</div>
          </div>
          <div className="col col-2 py1">
            <div className="h4">{drive.totalStock ? drive.totalStock : 0}</div>
          </div>
        </div>
      );
    });
  }

  renderTitle() {
    return <div className="h3">{I18n.t('driveInventory')}</div>;
  }

  render() {
    return (
      <div style={{ color: 'black' }}>
        {!this.props.shouldHideDriveTitle && this.renderTitle()}
        <div className="clearfix">
          <div className="col col-3 py1">
            <div className="h4">{I18n.t('type')}</div>
          </div>
          <div className="col col-2 py1">
            <div className="h4">{I18n.t('quantity')}</div>
          </div>
        </div>
        {this.renderDrives()}
      </div>
    );
  }
}

DriveInventoryView.propTypes = {
  drives: PropTypes.array,
};

export default DriveInventoryView;
